var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryChargingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,5h-6v-2c0-.6.4-1,1-1h4c.6,0,1,.4,1,1v2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,4h-8c-1.1,0-2,.9-2,2v14c0,1.1.9,2,2,2h8c1.1,0,2-.9,2-2V6c0-1.1-.9-2-2-2ZM10,19l1.5-5.6h-2.7l1.4-6.4h3.4l-1.1,4h3.2l-5.7,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryChargingIcon);
export default __webpack_public_path__ + "static/media/battery_charging_icon.950848ab90209f7ca0e23aa8d7b964d1.svg";
export { ForwardRef as ReactComponent };